import { MediaMatcher } from '@angular/cdk/layout';
import {
	Component,
	HostBinding,
	HostListener,
	OnDestroy,
	OnInit,
	ViewEncapsulation
} from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { showConfirmAlert } from 'src/app/utils/alert';
import { AuthService } from '../../services/auth.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { loadingAction } from '../../shared/state/actions/loading.action';
import { ApplicationStore } from '../../shared/state/store/index';
import { getUserAvatar } from '../../utils/avatar';
import { validateAccess } from '../../utils/role';
import { environment } from './../../../environments/environment';

@Component({
	selector: 'app-layout',
	templateUrl: './layout.component.html',
	styleUrls: ['./layout.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit, OnDestroy {
	@HostBinding('class') className = 'defaultTheme';

	currentYear: number = new Date().getFullYear();
	mobileQuery: boolean = false;
	isExpanded: boolean = false;
	pmticExpanded: boolean = false;
	rutaExpanded: boolean = false;
	proyectsExpanded: boolean = false;
	recursosExpanded: boolean = false;
	serviciosExpanded: boolean = false;
	menuGestionPedExpanded: boolean = false;
	resumeExpanded: boolean = false;
	linksExpanded: boolean = false;
	projectsExpanded: boolean = false;
	experiencesExpanded: boolean = false;
	gestionUsuariosExpanded: boolean = false;

	darkMode: boolean = false;
	routerEvents = new Subscription();
	isAdmin: boolean = false;
	userAvatar: { initials?: string; color?: string } = {};
	/* urlAvatar: string = 'https://gestionpedagogica.valledelcauca.gov.co';
	urlIndentifier: string = '';
	urlEditProfile: string = `${this.urlAvatar}/vusuarios/users/edit/${this.urlIndentifier}`; */
	subMenuExpanded: boolean = false;
	urlSST = environment.urlSST;

	constructor(
		private readonly media: MediaMatcher,
		private readonly router: Router,
		private readonly ls: LocalStorageService,
		private readonly authService: AuthService,
		private readonly store: Store<ApplicationStore>
	) {
		this.onResize();
		this.routerEvents = this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe((v) => {
				if (v instanceof NavigationEnd && v.url) {
					this.resumeExpanded = v.url.includes('/hoja-vida-institucional');
					this.rutaExpanded = v.url.includes('/ruta');
					this.recursosExpanded = v.url.includes('/recursos');
					this.pmticExpanded = v.url.includes('/pmtic');
					this.projectsExpanded = v.url.includes('/proyectos-pedagogicos');
					this.experiencesExpanded = v.url.includes(
						'/experiencias-significativas'
					);
					this.serviciosExpanded = v.url.includes('/servicios');
					this.menuGestionPedExpanded = v.url.includes('/gp-');
				}
			});
		this.isAdmin = this.ls.isAdmin;
		router.events.subscribe(() => {
			this.isExpanded = this.mobileQuery ? false : this.isExpanded;
		});
	}

	ngOnInit(): void {
		this.isExpanded = this.ls.getItem('menu_expanded', 'false') === 'true';
		this.darkMode = this.ls.getItem('dark_mode', 'false') === 'true';
		this.userAvatar = getUserAvatar(this.ls.getItem('name'));
		/* this.urlIndentifier = this.ls.getItem('identifier');
		console.log(this.urlIndentifier, 'Here'); */

		this.changeTheme(this.darkMode);
	}

	@HostListener('window:resize')
	onResize() {
		this.mobileQuery = this.media.matchMedia('(max-width: 600px)').matches;
	}

	toggleMenu() {
		this.isExpanded = !this.isExpanded;
		this.ls.saveItem(
			'menu_expanded',
			this.mobileQuery ? 'false' : String(this.isExpanded)
		);
	}

	changeTheme(dark: boolean) {
		this.className = dark ? 'darkMode' : 'defaultTheme';
	}

	changeToggle({ checked }: MatSlideToggleChange) {
		this.darkMode = checked;
		this.changeTheme(this.darkMode);
		this.ls.saveItem('dark_mode', String(checked));
	}
	redirectToUrl(event: Event): void {
		event.preventDefault();

		const token = this.ls.getItem('refresh');
		const url = `${this.urlSST}/login?hash=${token}`;
		window.open(url, '_blank');
	}

	logout() {
		showConfirmAlert({
			message:
				'¿Está seguro que desea cerrar la sesión?<br>Para volver a acceder al sistema, será necesario iniciar sesión nuevamente.',
			customClass: 'logout-alert',
			callBack: () => {
				this.cleanUp();
				this.store.dispatch(loadingAction({ loading: true }));
				this.authService.logout();
				window.location.href = '/auth/login';
				this.store.dispatch(loadingAction({ loading: false }));
			}
		});
	}

	getPermission(moduleName: string, subModule?: string) {
		return validateAccess(moduleName, subModule);
	}

	modulesPermissions() {
		return (
			this.getPermission('route', 'autoevaluation') ||
			this.getPermission('route', 'plan') ||
			this.getPermission('route', 'tracking')
		);
	}

	private cleanUp(): void {
		this.routerEvents.unsubscribe();
	}

	ngOnDestroy(): void {
		this.cleanUp();
	}

	toogleSubMenu() {
		this.subMenuExpanded = !this.subMenuExpanded;
	}
}
